import { BaseSignedOrder, OrderType } from "@/api/orders/types";
import {
  addPercentageOnAmount,
  roundToDecimal,
  toHighDenom,
  toLowDenom,
} from "@/shared/currencies";
import { isExpiredInSeconds } from "@/shared/dates";
import usePaymentCurrency from "@/shared/hooks/usePaymentCurrency";
import { useMemo } from "react";

export default function useReservePrice(auction: BaseSignedOrder) {
  const paymentMethod = usePaymentCurrency(auction?.paymentErc20TokenAddress);

  return useMemo(() => {
    if (!auction || auction.type !== OrderType.RESERVE_AUCTION) {
      return;
    }

    let reservePrice;

    const askingPrice = auction.price;
    const highestBid = auction.endingPrice;

    if (!highestBid) {
      reservePrice = askingPrice;
    } else if (!isExpiredInSeconds(auction.expiresAt)) {
      reservePrice = addPercentageOnAmount(BigInt(highestBid), 10).toString();
    } else {
      reservePrice = highestBid;
    }

    const reservePriceInHighDenom = toHighDenom(
      reservePrice,
      paymentMethod?.decimals,
    );

    return {
      raw: toLowDenom(roundToDecimal(reservePriceInHighDenom), 18),
      rounded: roundToDecimal(reservePriceInHighDenom),
    };
  }, [auction, paymentMethod?.decimals]);
}
